<dialog-title [ngSwitch]="data?.reason">
    <h1 *ngSwitchCase="'REGION_NOT_FOUND'">Błędny kod pocztowy</h1>
    <h1 *ngSwitchCase="'NEWSLETTER.MEMBER.EXISTS'">Kontakt już istnieje</h1>
    <h1 *ngSwitchDefault>Wystąpił nieoczekiwany błąd</h1>
</dialog-title>
<dialog-content [ngSwitch]="data?.reason">
    <ng-container *ngSwitchCase="'REGION_NOT_FOUND'">
        Nie udało się odnaleźć dostawcy energii dla podanego kodu pocztowego. Spróbuj ponownie z innym kodem pocztowym. 
    </ng-container>
    <ng-container *ngSwitchCase="'NEWSLETTER.MEMBER.EXISTS'">
        Nie udało się stworzyć nowego wpisuj na naszej liście kontaktów. Wygląda na to że Twoje dane są już w naszej bazie.
    </ng-container>
    <ng-container *ngSwitchDefault></ng-container>
</dialog-content>
<dialog-actions>
    <button sc-stroked-button (click)="close()">Zamknij</button>
</dialog-actions>